import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global ResizeObserver error suppression
// This catches the "ResizeObserver loop completed with undelivered notifications" error
// which is a common, harmless error that occurs when ResizeObserver callbacks
// trigger layout changes that cause the observer to fire again
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = args[0];
  if (
    typeof errorMessage === 'string' &&
    errorMessage.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Suppress this specific error as it's harmless and very common
    return;
  }
  // Log all other errors normally
  originalConsoleError.apply(console, args);
};

// Also suppress the error at the window level
// Use capture phase (true) to catch before webpack-dev-server
window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
